import daysjs from 'dayjs'
import {TREE_MAX_EVENT_DATE} from 'consts'

export function fototreeMaxEventDate(eventStartDate: string) {
  const startDate = daysjs(eventStartDate)
  const maxDate = startDate.add(TREE_MAX_EVENT_DATE - 1, 'day')
  return maxDate.format('YYYY-MM-DD')
}
